import { Utils } from 'common';
import React, { useContext } from 'react';
import { CancelAccountContext } from './CancelAccount.context';

const { Session } = Utils;

const ClickToCallConfirmation = () => {
	const cancelAccountContext = useContext(CancelAccountContext);

	return (
		<div className="click-to-call-confirmation">
			<h1 className="primary-header">Connecting....</h1>
			<p>
				We are calling you now at {cancelAccountContext.ClickToCallPhoneNumber}.
				When your phone rings, please answer it. In case you don’t receive the
				call within the next minute, please call us at 1-877-695-3859.
				<br />
				<br />
				Thank you, <br />
				Your Stamps.com Customer Care Team
			</p>
		</div>
	);
};

export default ClickToCallConfirmation;
